import { render, staticRenderFns } from "./SearchButton.vue?vue&type=template&id=dc55b912&"
import script from "./SearchButton.vue?vue&type=script&lang=ts&"
export * from "./SearchButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports